/**
 * Custom event for swiper to disable autoplay on interaction
 * @param {*} ref Swiper ref
 * @returns
 */
export const disableOnInteraction = (ref) => {
  if (!ref) return
  if (ref?.$swiper?.autoplay?.running) {
    ref.$swiper.autoplay.stop();
  }
}

/**
 * Custom mount event for swiper
 * @param {*} el Vue instance on existing DOM element (vm.$el https://v2.vuejs.org/v2/api/#el)
 * @param {*} ref Swiper ref 
 * @returns
 */
export const mountEvents = (el, ref) => {
  if (!el || !ref) return

  el.addEventListener('touchstart', () => {
    disableOnInteraction(ref)
  }, {
    passive: true,
    once: true
  })
  el.addEventListener('mouseenter', () => {
    disableOnInteraction(ref)
  }, {
    passive: true,
    once: true
  })
  el.addEventListener('focus', () => {
    el.focus()
    disableOnInteraction(ref)
  }, true)
}